import React from 'react';
import Img8 from '../../assets/images/team arm care.png';
import {EmptyCard, EmptyImage, Navbar} from '../../components';

export default () => {
  return (
    <>
      <Navbar />
      <div style={{display: 'flex', marginTop: '10px', flexDirection: 'column', alignItems: 'center'}}>
        <EmptyCard />
        <EmptyImage src={Img8} />
      </div>
    </>
  );
};
